<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('yqddgl')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('phone')">
                                    <el-input v-model="searchform.phone" @keyup.enter.native="onSubmit" size="small" style="width: 130px;"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('mchOrderNo')">
                                    <el-input v-model="searchform.mchOrderNo" @keyup.enter.native="onSubmit" size="small" style="width: 140px;"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('bookName')">
                                    <el-select size="small" v-model="searchform.accountId" style="width:150px;" :placeholder="$t('pleaseZhangqi')"  >
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option v-for="(item,index) in accountlist" :label="item.bookName" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('csy')">
                                    <el-select size="small" v-model="searchform.principalId" filterable clearable style="width:150px;" :placeholder="$t('qxzcsymc')" >
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option v-for="(item,index) in principallist1" :label="item.nickName" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('type')">
                                    <el-select v-model="searchform.statusValue" style="width:120px;">
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option :label="$t('loan4')" :value="0"></el-option>
                                        <el-option :label="$t('loan5')" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('time')">
                                    <el-date-picker
                                    v-model="value1"
                                    type="datetimerange"
                                    size="small"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>

                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="searchright">
                            <el-button size="small" type="primary" @click="distributor">{{$t('fp')}}</el-button>
                        </div>
                    </div>
                    <el-table :data="list" @selection-change="handleSelectionChange"
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column type="selection" width="55"></el-table-column>
                        
                        <el-table-column prop="mchOrderNo" :label="$t('mchOrderNo')"></el-table-column>
                        <el-table-column prop="callName" :label="$t('csy')"></el-table-column>
                        <el-table-column prop="overdueDay" :label="$t('overdueDay')"></el-table-column>
                        <el-table-column prop="expireTime" :label="$t('expireTime')"></el-table-column>
                        <el-table-column prop="level" :label="$t('ckrq')">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="days" :label="$t('days')"></el-table-column>
                        <el-table-column prop="cantidad" :label="$t('cantidad')"></el-table-column>
                        <!-- <el-table-column prop="userName" :label="$t('userName')"></el-table-column>
                        <el-table-column prop="phone" :label="$t('phone')"></el-table-column>
                        <el-table-column prop="email" :label="$t('email')"></el-table-column>
                        <el-table-column prop="exclusiveLinks" :label="$t('exclusiveLinks')"></el-table-column> -->
                        <el-table-column prop="platform" :label="$t('pingt')"></el-table-column>
                        <!-- <el-table-column prop="agingDetail" :label="$t('fqcs')" width="120px"></el-table-column> -->
                        <el-table-column prop="statusValue" :label="$t('status')" width="100">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.statusValue == 0" type="info">{{$t('loan4')}}</el-tag>
                                <el-tag v-if="scope.row.statusValue == 1" type="info">{{$t('loan5')}}</el-tag>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="jobName" label="操作" width="150">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="认证信息" placement="top">
                                     <el-button size="small"  @click="openextend(scope.row)"  type="primary" icon="el-icon-menu" circle plain></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="催收信息" placement="top">
                                     <el-button size="small"  @click="opencall(scope.row)"  type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column> -->
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>

        <pop-up :title="$t('fp')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small" label-width="300px">
                    <el-form-item :label="$t('csy')" prop="principalId">
                        <el-select size="small" v-model="form.principalId"  filterable clearable  :placeholder="$t('qxzcsymc')" style="width:300px;">
                            <el-option :label="$t('qxzcsymc')" :value="null"></el-option>
                            <el-option
                            v-for="item in principallist"
                            :key="item.id"
                            :label="item.nickName"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    mchOrderNo: null,
                    email: null,
                    userName: null,
                    cantidad: null,
                    days: null,
                    overdueDay: null,
                    expireTime: null,
                    createTime: null,
                    exclusiveLinks:null,
                    stats: null
                },
                rules:{
                    principalId:[{ required: true, trigger: 'blur' },]
                },
                searchform: {
                    blurry: "",
                    accountId: null,
                    principalId: null,
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                loading: false,
                showadd: false,
                list: [],
                value1:[],
                searchform:{},
                total: 1,
                pageNo: 1,
                pageSize: 10,
                keyword: '',
                user:null,
                rolelist: [],
                status: null,
                principallist:[],
                multipleSelection: [],
                selectData:null,
                accountlist: [],
                principallist1:[],

            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
            this.getprincipal()
            this.getprincipal1()
            this.getaccount()
        },

        // :disabled="!searchform.accountId"
        // watch: {
        //     'searchform.accountId'(newVal) {
        //         // 清空之前的 csy 选择
        //         //this.searchform.principalId = null
        //         this.principallist1 = []

        //         // 只有选了账期才请求
        //         if (newVal) {
        //             this.getprincipal1()
        //         }
        //     }
        // },
        methods: {
            distributor() {
                this.showadd = true
                this.form = {
                    id: null,
                    selectData: this.selectData,
                    principalId:null,
                    nation:localStorage.getItem("nation"),
                }
            },
            getaccount() {
                _api.get(apiurl.accountBook, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.accountlist = res.data
                })
            },
            getprincipal() {
                _api.get(apiurl.users, {
                    roleId: 3,
                    nation:localStorage.getItem("nation"),
                    //iden: 1
                }).then(res => {
                    this.principallist = res.content
                })
            },
            getprincipal1() {
                _api.get(apiurl.users, {
                    roleId: 3,
                    nation:localStorage.getItem("nation"),
                    //groupId: this.searchform.accountId
                }).then(res => {
                    this.principallist1 = res.content || []
                })
            },
            openextend(row){
                this.$router.push({path:"/userlist/extend",query:{id:row.userId,phone:row.phone}})
            },
            opencall(row){
                this.$router.push({path:"/callorder/call",query:{orderId:row.id,userId:row.userId}})
            },
            handleSelectionChange(val) {
                var authority = [];
                this.multipleSelection = val;
                for(var i = 0; i< this.multipleSelection.length; i++){
                    authority.push(this.multipleSelection[i].id)
                }
                this.selectData=authority.join(",");
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            getconfirm() {
                if (this.selectData == null) {
                    this.$message.error(this.$t('qgxfpdd'))
                    return
                }
                if (this.form.principalId == null || this.form.principalId=="") {
                    this.$message.error(this.$t('qxzcsymc'))
                    return
                }
                _api.post(apiurl.distributor, this.form)
                .then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('addSuccess')
                    })
                    this.getList()
                    this.showadd = false
                    this.form = {
                        id: null,
                        selectData: null,
                        principalId:null
                    }
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            getList() {
                this.loading = true
                _api.get(apiurl.callorder, {
                    page: this.pageNo,
                    size: this.pageSize,
                    phone: this.searchform.phone,
                    mchOrderNo: this.searchform.mchOrderNo,
                    createTime: this.value1,
                    nation:localStorage.getItem("nation"),
                    accountId:this.searchform.accountId,
                    principalId:this.searchform.principalId,
                    type: this.searchform.statusValue
                }).then(res => {
                    this.loading = false
                    this.list = res.data.data
                    this.total = res.data.totalCount
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }

    .searchright{
        padding-bottom: 10px;
    }

</style>